import { useSearchParams } from 'next/navigation'
import { stringifyUrl } from 'query-string'
import * as React from 'react'

import { ProductCatalogLink } from '../../../../../../__generated__/graphql/catalog/graphql'
import { NextLink } from '../../../../../../app/_components/navigation/NextLink'
import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { trackEvent } from '../../../../../../lib/analytics'
import { CollectionLink } from '../../../../../../types/graphql'

import { Body, LinkItem, Links, ListWrapper, Title } from './styles'

// Note: CollectionLink is deprecated.
export type CollectionLinksProps = {
  links: ProductCatalogLink[] | CollectionLink[]
}

export const CollectionLinks = ({ links }: CollectionLinksProps) => {
  const {
    detailsSection: { collectionLinksTitle },
  } = useTranslation()
  // plain=true query param is used by iOS app to view webpages within a webview without the website's header/footer
  const plainQueryParamValue = useSearchParams()?.get('plain') ?? undefined

  if (!links.length) return null

  const getItemUrl = (url: string) => {
    const query = { plain: plainQueryParamValue }
    return stringifyUrl({ url, query })
  }

  return (
    <Body>
      <Title textTransform='uppercase'>{collectionLinksTitle}</Title>
      <Links>
        {links.map(link => (
          <ListWrapper key={link.text}>
            <NextLink href={getItemUrl('url' in link ? link.url : link.href)}>
              <LinkItem
                {...trackEvent({
                  category: 'product-details',
                  action: 'category-link',
                  label: link.text,
                })}
              >
                {link.text}
              </LinkItem>
            </NextLink>
          </ListWrapper>
        ))}
      </Links>
    </Body>
  )
}
